import { Theme } from '@material-ui/core/styles';

export const getMuiTab = (theme: Theme): Record<string, unknown> => ({
  MuiTab: {
    root: {
      margin: theme.spacing(0, 0.25),
      minWidth: 0,
      width: 'unset',
    },

    textColorInherit: {
      opacity: 1,
      padding: theme.spacing(1.5, 0),

      '&.Mui-selected': {
        boxShadow: `inset 0px -3px 0px 0px ${theme.palette.primary.main}`,
      },
    },

    wrapper: {
      color: theme.palette.grey[800],
      fontWeight: 'normal',
      textTransform: 'capitalize',
    },
  },
});
